/**
 * uiReducer.ts — Reducer for local UI state.
 *
 * UI-INV-009: useReducer for structured/multi-field state.
 * This manages overlay visibility, completion ceremony,
 * first-launch detection, and the scheduling flow (M2-UX-P0-011).
 * NOT engine state.
 *
 * Note: Some actions (PERMISSIONS_GRANTED, CONFIRM_SCHEDULE, etc.)
 * have localStorage side effects via schedulingState module.
 * This is an accepted trade-off — the alternative is a middleware
 * layer that would add complexity without benefit at this scale.
 */
import type { UIState, UIAction } from './types';
import { uiHandlers } from './uiHandlers';

export { createInitialUIState } from './initialUIState';

/**
 * uiReducer — manages UI state transitions.
 *
 * Side effects (localStorage writes) are isolated in the scheduling
 * action handlers via the schedulingState module.
 */
export function uiReducer(state: UIState, action: UIAction): UIState {
  const handler = uiHandlers[action.type];
  return handler ? (handler as (s: UIState, a: UIAction) => UIState)(state, action) : state;
}
